// in src/OutOfHomeCampaign/UploadSpreadsheets.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import config from 'react-global-configuration';
import {CloudUpload} from "@material-ui/icons";

class UploadSpreadsheets extends Component {

    handleClick = () => {

        const webUrl = config.get('app.web_url');
        const {record } = this.props;
        window.open(`${webUrl}/out_of_home_upload/?uuid=${record.originId}`, '_self');
    }

    render() {
        return <Button variant="text" color="primary" size="small" onClick={this.handleClick}>
        <CloudUpload /> &nbsp; Upload files
        </Button>;
    }
}

UploadSpreadsheets.propTypes = {
    record: PropTypes.object,
};

export default connect(null, null)(UploadSpreadsheets);